<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>报表管理</el-breadcrumb-item>
      <el-breadcrumb-item>门店成本占比统计表</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="display: flex;justify-items: center">
      <el-date-picker
        v-model="reportRequest.selectMonth"
        type="monthrange"
        range-separator="至"
        size="mini"
        start-placeholder="开始月份"
        end-placeholder="结束月份"
        @change="selectReportDataMonth"
        value-format="yyyy-MM"
      >
      </el-date-picker>
      <el-select value filterable v-model="selectAreaId" v-if="orgLevel == 1" placeholder="请选择区域" clearable
                 style="width: 200px" size="mini" @change="getArea">
        <el-option
          v-for="item in areas"
          :key="item.id"
          :label="item.orgName"
          :value="item.id">
        </el-option>
      </el-select>
      <el-select v-model="selectOrgId" v-if="orgLevel < 3 && tabName === 'bfb'" clearable value filterable placeholder="请选择门店"
                 style="width: 200px" size="mini" @change="getShop">
        <el-option
          v-for="org in shops"
          :key="org.id"
          :label="org.orgName"
          :value="org.id">
        </el-option>
      </el-select>
      <el-button size="mini" style="margin-left: 5px;" @click="loadData">查询</el-button>
    </div>
    <el-tabs  @tab-click="reportTabNameClick" type="border-card" style="height: 650px">
      <el-tab-pane label="百分比" name="bfb">
        <el-table height="550px" :data="shopZbDataList" fit border stripe="stripe"
                  :header-cell-style="{background:'#eff3f8', color:'#333'}"
                  ref="tableName"
                  show-summary>
          <el-table-column
            align="center"
            prop="shopName"
            label="门店"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="yeji"
            label="业绩合计"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            label="消费单退费警戒线"
            width="150"
          >
            <template slot-scope="scope">
              {{scope.row.xiaofeidantuifei}}%
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="消费单退费"
            width="150"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.xiaofeidantuifeijjx - scope.row.xiaofeidantuifei < 0" style="color: #FA5858">{{scope.row.xiaofeidantuifei}}%</span>
              <span v-if="scope.row.xiaofeidantuifeijjx - scope.row.xiaofeidantuifei >= 0">{{scope.row.xiaofeidantuifei}}%</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="支付银行手续费警戒线"
            width="150"
          >
            <template slot-scope="scope">
              {{scope.row.zhifuyinxingshouxufeijjx}}%
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="支付银行手续费"
            width="150"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.zhifuyinxingshouxufeijjx - scope.row.zhifuyinhangshouxufei < 0" style="color: #FA5858">{{scope.row.zhifuyinhangshouxufei}}%</span>
              <span v-if="scope.row.zhifuyinxingshouxufeijjx - scope.row.zhifuyinhangshouxufei >= 0">{{scope.row.zhifuyinhangshouxufei}}%</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="货款警戒线"
            width="150"
          >
            <template slot-scope="scope">
              {{scope.row.huokuanjjx}}%
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="货款"
            width="150"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.huokuanjjx - scope.row.huokuan < 0" style="color: #FA5858">{{scope.row.huokuan}}%</span>
              <span v-if="scope.row.huokuanjjx - scope.row.huokuan >= 0">{{scope.row.huokuan}}%</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="营业支出警戒线"
            width="150"
          >
            <template slot-scope="scope">
              {{scope.row.yingyezhichujjx}}%
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="营业支出"
            width="150"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.yingyezhichujjx - scope.row.yingyezhichu < 0" style="color: #FA5858">{{scope.row.yingyezhichu}}%</span>
              <span v-if="scope.row.yingyezhichujjx - scope.row.yingyezhichu >= 0">{{scope.row.yingyezhichu}}%</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="绩效工资警戒线"
            width="150"
          >
            <template slot-scope="scope">
              {{scope.row.jixiaogongzijjx}}%
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="绩效工资"
            width="150"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.jixiaogongzijjx - scope.row.jixiaogongzi < 0" style="color: #FA5858">{{scope.row.jixiaogongzi}}%</span>
              <span v-if="scope.row.jixiaogongzijjx - scope.row.jixiaogongzi >= 0">{{scope.row.jixiaogongzi}}%</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="福利成本警戒线"
            width="150"
          >
            <template slot-scope="scope">
              {{scope.row.fulichengbenjjx}}%
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="福利成本"
            width="150"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.fulichengbenjjx - scope.row.fulichengben < 0" style="color: #FA5858">{{scope.row.fulichengben}}%</span>
              <span v-if="scope.row.fulichengbenjjx - scope.row.fulichengben >= 0">{{scope.row.fulichengben}}%</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="支付广告费警戒线"
            width="150"
          >
            <template slot-scope="scope">
              {{scope.row.zhifuguanggaofeijjx}}%
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="支付广告费"
            width="150"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.zhifuguanggaofeijjx - scope.row.zhifuguanggaofei < 0" style="color: #FA5858">{{scope.row.zhifuguanggaofei}}%</span>
              <span v-if="scope.row.zhifuguanggaofeijjx - scope.row.zhifuguanggaofei >= 0">{{scope.row.zhifuguanggaofei}}%</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="门店保险警戒线"
            width="150"
          >
            <template slot-scope="scope">
              {{scope.row.mendianbaoxianjjx}}%
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="门店保险"
            width="150"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.mendianbaoxianjjx - scope.row.mendianbaoxian < 0" style="color: #FA5858">{{scope.row.mendianbaoxian}}%</span>
              <span v-if="scope.row.mendianbaoxianjjx - scope.row.mendianbaoxian >= 0">{{scope.row.mendianbaoxian}}%</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="支付培训费警戒线"
            width="150"
          >
            <template slot-scope="scope">
              {{scope.row.zhifupeixunfeijjx}}%
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="支付培训费"
            width="150"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.zhifupeixunfeijjx - scope.row.zhifupeixunfei < 0" style="color: #FA5858">{{scope.row.zhifupeixunfei}}%</span>
              <span v-if="scope.row.zhifupeixunfeijjx - scope.row.zhifupeixunfei >= 0">{{scope.row.zhifupeixunfei}}%</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="门店房租警戒线"
            width="150"
          >
            <template slot-scope="scope">
              {{scope.row.mendianfangzujjx}}%
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="门店房租"
            width="150"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.mendianfangzujjx - scope.row.mendianfangzu < 0" style="color: #FA5858">{{scope.row.mendianfangzu}}%</span>
              <span v-if="scope.row.mendianfangzujjx - scope.row.mendianfangzu >= 0">{{scope.row.mendianfangzu}}%</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="门店其他支出警戒线"
            width="150"
          >
            <template slot-scope="scope">
              {{scope.row.mendianqitazhichujjx}}%
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="门店其他支出"
            width="150"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.mendianqitazhichujjx - scope.row.mendianqitazhichu < 0" style="color: #FA5858">{{scope.row.mendianqitazhichu}}%</span>
              <span v-if="scope.row.mendianqitazhichujjx - scope.row.mendianqitazhichu >= 0">{{scope.row.mendianqitazhichu}}%</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="门店其他收入警戒线"
            width="150"
          >
            <template slot-scope="scope">
              {{scope.row.mendianqitashourujjx}}%
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="门店其他收入"
            width="150"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.mendianqitashourujjx - scope.row.mendianqitashouru < 0" style="color: #FA5858">{{scope.row.mendianqitashouru}}%</span>
              <span v-if="scope.row.mendianqitashourujjx - scope.row.mendianqitashouru >= 0">{{scope.row.mendianqitashouru}}%</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="净利润警戒线"
            width="150"
          >
            <template slot-scope="scope">
              {{scope.row.jinglirunjjx}}%
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="净利润"
            width="150"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.jinglirunjjx - scope.row.jinglirun > 0" style="color: #FA5858">{{scope.row.jinglirun}}%</span>
              <span v-if="scope.row.jinglirunjjx - scope.row.jinglirun <= 0">{{scope.row.jinglirun}}%</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="会员消费预警警戒线"
            width="150"
          >
            <template slot-scope="scope">
              {{scope.row.huiyuanxiaofeiyujingjjx}}%
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="会员消费预警"
            width="150"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.huiyuanxiaofeiyujingjjx - scope.row.huiyuanxiaofeiyujing < 0" style="color: #FA5858">{{scope.row.huiyuanxiaofeiyujing}}%</span>
              <span v-if="scope.row.huiyuanxiaofeiyujingjjx - scope.row.huiyuanxiaofeiyujing >= 0">{{scope.row.huiyuanxiaofeiyujing}}%</span>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="数据值" name="sz">
        <el-table height="550px" :data="shopZbValueList" fit border stripe="stripe"
                  :header-cell-style="{background:'#eff3f8', color:'#333'}"
                  ref="tableName"
                  show-summary>
          <el-table-column
            align="center"
            prop="shopName"
            label="门店"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="yeji"
            label="业绩合计"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="xiaofeidantuifei"
            label="消费单退费"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="caiwufeiyoing"
            label="支付银行手续费"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="huokuan"
            label="货款"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="yingyezhichu"
            label="营业支出"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="jixiaogongzi"
            label="绩效工资"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="fulichengben"
            label="福利成本"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="zhifuguanggaofei"
            label="支付广告费"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="mendianbaoxian"
            label="门店保险"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="peixunfei"
            label="支付培训费"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="mendianfangzu"
            label="门店房租"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="mendianqitazhichu"
            label="门店其他支出"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="mendianqitashouru"
            label="门店其他收入"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="jinglirun"
            label="净利润"
            width="150"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="huiyuan"
            label="会员消费预警"
            width="150"
          >
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data(){
    return{
      userId:'',
      shopId:'',
      orgLevel:'',
      authorities:'',
      shopZbDataList:[],
      shopZbValueList:[],
      selectAreaId:'',
      selectOrgId:'',
      areas:[],
      shops:[],
      users:[],
      reportRequest:{
        selectMonth:'',
        startMonth:'',
        endMonth:'',
        shopId:0,
        areaId:0,
      },
      tabName:'',
    }
  },
  methods:{
    selectReportDataMonth(data){
      if (data == null){
        this.reportRequest.selectMonth = '';
      } else {
        this.reportRequest.startMonth = data[0];
        this.reportRequest.endMonth = data[1];
      }
    },
    getShop(data){
      if (data !== ''){
        this.reportRequest.shopId = data;
      } else {
        this.reportRequest.shopId = 0;
      }
    },
    async loadAreaOrgs(){
      const {data:res} = await this.$http.get(`/orgs/area/orgId/${this.shopId}`);
      if (res.code === 200){
        this.areas = res.data;
      }
    },
    getArea(data){
      this.reportRequest.areaId = data;
      this.reportRequest.shopId = 0;
    },
    loadData(){
      if (this.tabName === 'bfb'){
        this.loadBfbData();
      }
      if (this.tabName === 'sz'){
        this.loadSzData();
      }
    },
    async loadBfbData(){
      if (this.reportRequest.selectMonth === ''){
        return this.$message.warning("请选择月份进行查询");
      }
      const {data:res} = await this.$http.post(`/shop/zb/data`, this.reportRequest);
      this.shopZbDataList = res.data.reportShopZbs;
      this.shops = res.data.shopList;
    },
    async loadSzData(){
      if (this.reportRequest.selectMonth === ''){
        return this.$message.warning("请选择月份进行查询");
      }
      const {data:res} = await this.$http.post(`/shop/zb/sj/data`, this.reportRequest);
      this.shopZbValueList = res.data;
    },
    reportTabNameClick(tab, event){
      this.tabName = tab.name;
      if (tab.name === 'bfb'){
        this.loadBfbData();
      }
      if (tab.name === 'sz'){
        this.loadSzData();
      }
    }
  },


  created() {
    this.shopId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.orgLevel = window.sessionStorage.getItem("orgLevel");
    this.authorities = window.sessionStorage.getItem('authorities');
    if (this.orgLevel == 1){
      this.loadAreaOrgs();
    }
    if (this.orgLevel == 2){
      this.reportRequest.areaId = this.shopId;
      this.getArea(this.shopId);
    }
    if (this.orgLevel == 3){
      this.reportRequest.shopId = this.shopId;
    }
  }
}
</script>

<style lang="less" scoped>
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
    text-align: center !important;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/.el-input__inner{
  height: 30px;
  line-height: 30px;
}
/deep/.el-input__icon,.el-icon-date{
  line-height: 35px;
}
/deep/.el-input__icon, .el-range__icon, .el-icon-date{
  line-height: 25px;
}
/deep/.el-range-separator{
  line-height: 23px;
}
.dialog-footer{
  display: flex;
  margin: 30px 20px 20px 0;
  justify-content: center;
  width: 100%;
}
/deep/.el-button--text{
  color: #ecf5ff;
}
.el-table {
  overflow: visible !important;
  //overflow: auto !important;
}

/deep/.el-tabs--card>.el-tabs__header {
  border-bottom: 1px solid #E4E7ED;
}
/deep/.el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 10px;
}
/deep/.el-tabs__content {
  overflow: hidden;
  position: relative;
  height: 600px;
}
/deep/.el-table__body-wrapper .is-scrolling-left{
  height: 483px;
}
/deep/.el-tabs__content.el-table__fixed{
  height: 539px;
}
/deep/ .el-table__fixed{
  height: 100% !important;
}
/deep/ .el-table__fixed-right,.el-table__fixed-body-wrapper{
  height: 100% !important;
}

</style>



// WEBPACK FOOTER //
// src/components/ShopCb.vue